import { Directive, SkipSelf } from "@angular/core";
import { IOnModelChange } from "../../common-form.interface";
import { CommonFieldManagerDirective } from "../../field-manager.directive";
import { ChoiceFieldActionsDirective } from "../choicefield-actions.directive";

@Directive({
    selector: "[common-dropdown-actions]",
    exportAs: "DropdownActions",
})
export class CommonDropdownActionsDirective implements IOnModelChange {

    constructor(
        @SkipSelf() public fieldManager: CommonFieldManagerDirective,
        public fieldActions: ChoiceFieldActionsDirective,
    ) { }

    public onModelChange(value, index?) {
        if (value !== this.fieldManager.fieldValue) {
            this.dispatchChanges(value, index);
        }
    }

    public filterOptions(payload) {
        this.fieldActions.getList(payload, true);
    }

    public resetOptions() {
        this.fieldActions.getList(undefined, true);
    }

    public dispatchChanges(value, index?) {
        this.fieldManager.dispatchFieldUpdate(value, index);
        this.fieldManager.dispatchFormFieldChange(value);
        if (this.fieldManager.fieldType.match(/^dropdown$|^filteredDropdown$/)) {
            setTimeout(() => {
                this.resetOptions();
            }, 1000);
        }
    }
}
